import { useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import PageMenu from 'components/blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import Loader from 'components/blocks/Loader/Loader';
import ErrorDisplay from 'components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla';
import useDecode from 'hooks/useDecode';
import SolicitudGastosFarmacia from './SolicitudGastosFarmacia';
import useGetSolicitudGastosFarmaciaByID from 'services/record/SolicitudGastosFarmacia/useGetSolicitudGastosFarmaciaByID';

const HistorialSolicitudGastosFarmacia = ({ expedienteId = null, origen = null }) => {
    const decoded = useDecode("token");
    const userId = decoded?.extension_id;
    const [data, setData] = useState(null);
    const navigate = useNavigate();
    const { getSolicitudGastosFarmaciaByID, loadingGetSolicitudGastosFarmaciaByID, statusGetSolicitudGastosFarmaciaByID } = useGetSolicitudGastosFarmaciaByID();
    const { idprestacion, idform } = useParams<Record<string, string>>();
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (payload: any) => (
        expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined
            ? { ...payload, ExpedienteIdByOrigen: expedienteIdByOrigen }
            : payload
    );

    useEffect(() => {
        const actualUrl = window.location.href;

        if (!actualUrl.includes('/mis-gestiones/formularios')) {
            const prestacionId = idprestacion?.split('_')[1] || idprestacion;
            const formId = idform;

            if (userId && prestacionId && formId) {
                getSolicitudGastosFarmaciaByID(userId, prestacionId, formId, (payload) => setData(dataUserWithExpedienteByOrigen(payload))).catch(() => undefined);
            }
        }
    }, [expedienteIdByOrigen, idform, idprestacion, userId]);

    return (
        <div>
            <PageMenu title={'Solicitud Gastos Farmacia'}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            {loadingGetSolicitudGastosFarmaciaByID ?
                <Loader activeLoader={true} label="Cargando Formulario" />
                : statusGetSolicitudGastosFarmaciaByID?.status && ![200, 204].includes(statusGetSolicitudGastosFarmaciaByID.status) ?
                    <ErrorDisplay descripcionError={statusGetSolicitudGastosFarmaciaByID.statusText} />
                    : data && <SolicitudGastosFarmacia dataUser={data} info={false} />
            }
        </div>
    );
};

export default HistorialSolicitudGastosFarmacia;
